import { createBrowserRouter, Navigate } from "react-router-dom";

// Public pages
import Home              from "@/pages/public/Home";
import About             from "@/pages/public/About";
import Contact           from "@/pages/public/Contact";
import Pricing           from "@/pages/public/Pricing";
import Terms             from "@/pages/public/Terms";
import Privacy           from "@/pages/public/Privacy";
import FreeTrialPicker   from "@/pages/public/FreeTrialPicker";
import FreeTrialReportEditor from "@/pages/public/FreeTrialReportEditor";

// Private pages
import Dashboard         from "@/pages/private/Dashboard";
import ReportFolders     from "@/pages/private/ReportFolders";
import { OwnedReportFolder } from "@/pages/private/OwnedReportFolder";
import { ReportCard }    from "@/pages/private/ReportCard";
import { ReportDefaults } from "@/pages/private/ReportDefaults";
import SharedReportFolders from "@/pages/private/SharedReportFolders";
import SharedReportFolder from "@/pages/private/SharedReportFolder";
import CreditsAndBilling from "@/pages/private/CreditsAndBilling";
import School            from "@/pages/private/School";

// Admin pages
import SchoolActivity              from "@/pages/private/admin/SchoolActivity";
import ManageReportFolderOwnership from "@/pages/private/admin/ManageReportFolderOwnership";
import ManageReportFolderSharing   from "@/pages/private/admin/ManageReportFolderSharing";
import AdminSettings               from "@/pages/private/admin/Settings";
import SeatManagement              from "@/pages/private/admin/SeatManagement";
import ReportFolderShares          from "@/pages/private/admin/ReportFolderShares";
import Members                     from "@/pages/private/admin/Members";

// Layouts
import RootLayout      from "@/layouts/root-layout";
import DashboardLayout from "@/layouts/dashboard-layout";
import PublicLayout    from "@/layouts/public-layout";
import RequireAdmin    from "@/layouts/RequireAdmin";
import NotFound        from "@/pages/NotFound";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        element: <PublicLayout />,
        children: [
          { path: "/",             element: <Home /> },
          { path: "/about",        element: <About /> },
          { path: "/contact",      element: <Contact /> },
          { path: "/pricing",      element: <Pricing /> },
          { path: "/terms",         element: <Terms /> },
          { path: "/privacy",       element: <Privacy /> },
          { path: "/free-trial",   element: <FreeTrialPicker /> },
          { path: "/free-trial/:reportType", element: <FreeTrialReportEditor /> },
          // Legacy free-trial routes → redirect to new unified path
          { path: "/pgrc",         element: <Navigate to="/free-trial/pgrc1to6_2023_07" replace /> },
          { path: "/pgrc78",       element: <Navigate to="/free-trial/pgrc7to8_2023_07" replace /> },
          { path: "/pvrc",         element: <Navigate to="/free-trial/pvrc1to6_2023_09" replace /> },
          { path: "/pvrc78",       element: <Navigate to="/free-trial/pvrc7to8_2023_09" replace /> },
          { path: "/pvrc9to12sem", element: <Navigate to="/free-trial/pvrc9to12_2022_02_sem" replace /> },
        ],
      },
      {
        element: <DashboardLayout />,
        children: [
          { path: "/dashboard",                                                       element: <Dashboard /> },
          { path: "/report-folders",                                                  element: <ReportFolders /> },
          { path: "/shared-report-folders",                                           element: <SharedReportFolders /> },
          { path: "/shared-report-folders/:sharedReportFolderId",                     element: <SharedReportFolder /> },
          { path: "/shared-report-folders/:sharedReportFolderId/reports/:id",         element: <ReportCard /> },
          { path: "/report-folders/:reportFolderId",                                  element: <OwnedReportFolder /> },
          { path: "/report-folders/:reportFolderId/defaults",                         element: <ReportDefaults /> },
          { path: "/report-folders/:reportFolderId/reports/:id",                      element: <ReportCard /> },
          { path: "/credits-and-billing",                                             element: <CreditsAndBilling /> },
          { path: "/usage",                                                           element: <Navigate to="/credits-and-billing" replace /> },
          { path: "/billing",                                                         element: <Navigate to="/credits-and-billing" replace /> },
          // School routes
          { path: "/schools",                  element: <School /> },
          // Admin-only school routes
          {
            element: <RequireAdmin />,
            children: [
              { path: "/schools/activity",                            element: <SchoolActivity /> },
              { path: "/schools/members",                             element: <Members /> },
              { path: "/schools/settings",                            element: <AdminSettings /> },
              { path: "/schools/report-folders",                      element: <ManageReportFolderOwnership /> },
              { path: "/schools/report-folders/:reportFolderId",      element: <ManageReportFolderOwnership /> },
              { path: "/schools/share-requests",                      element: <ManageReportFolderSharing /> },
              { path: "/schools/seats",                               element: <SeatManagement /> },
              { path: "/schools/report-folder-shares",                element: <ReportFolderShares /> },
            ],
          },
        ],
      },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
